import { AuthContext } from '@repo-level/core-front';
import { ConfigContext } from 'contexts/config';
import { getTimeLeft } from 'helpers/timer';
import { someGroupMember } from 'helpers/user';
import { useContext, useMemo } from 'react';
import { RESTRICTED_GROUPS } from '../constants';

export const useAvailable = () => {
  const { user } = useContext(AuthContext);
  const { headlinePromo, isHeadlinePromoDateValid } = useContext(ConfigContext);

  const isRestricted = useMemo(
    () => someGroupMember(RESTRICTED_GROUPS)(user),
    [user]
  );

  const timeLeft = useMemo(
    () => (headlinePromo ? Math.max(getTimeLeft(headlinePromo.end), 0) : 0),
    [headlinePromo]
  );

  return { isAvailable: isHeadlinePromoDateValid && !isRestricted, timeLeft };
};
